import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    name: ROUTES.ONBOARDING,
    path: 'onboarding',
    component: () => import('./pages/OnboardingIndex.vue'),
    meta: { shell: 'onboarding', title: 'Get Started' }
  }
]
